import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, ButtonResponsiveWrapper, StayInTheKnowIcon, useResponsive } from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import { BannerStorageKey } from '@/modules/core/components/Dashboard/components/BannersList/bannersList.constants';
import useDismissBanner from '@/modules/core/components/Dashboard/components/BannersList/hooks/useDismissBanner';

interface Props {
  openStayInTheKnowModal: () => void;
}

const StayInTheKnowBanner: React.FC<Props> = ({ openStayInTheKnowModal }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { handleDismissBanner } = useDismissBanner();

  const handleDismiss = useCallback(() => {
    handleDismissBanner(BannerStorageKey.StayInTheKnowBanner);
  }, [handleDismissBanner]);

  return (
    <Banner
      testId="stay-in-the-know"
      title={t('Stay in the Know')}
      description={t('Sign up for text alerts and never miss an update.')}
      icon={<StayInTheKnowIcon />}
    >
      <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
        <AppButton
          fill={isMobile}
          testId="stay-in-the-know_sign-up"
          onClick={openStayInTheKnowModal}
          width="180px"
        >
          {t('Sign Up')}
        </AppButton>

        <AppButton
          fill={isMobile}
          testId="stay-in-the-know_dismiss"
          buttonType="secondary"
          width="180px"
          onClick={handleDismiss}
        >
          {t('Dismiss')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </Banner>
  );
};

export default StayInTheKnowBanner;
